export default __webpack_public_path__ + "static/media/p3s2.ae229fcc.png";